export default __webpack_public_path__ + "static/media/TinoRossi.69498e72.mp3";